import authService from '../authentication/AuthorizeService';

const errorResponseHandler = (error) => {
  /*
    Errors can be user action too and response will be null. So removing this TODO code
    if (
    (error.response.status === 403 || error.response.status === 500) &&
    error.response.data &&
    error.response.data.exceptionMessage.toLowerCase().startsWith('invalid authorization token')
  ) {
    console.log(error.response);
  } */
  if (
    error.response.status === 401 &&
    error.response.data &&
    error.response.data.exceptionMessage &&
    error.response.data.exceptionMessage.toLowerCase().startsWith('invalid authorization token')
  ) {
    authService.signOut();
  }
  return Promise.reject(error);
};

const successResponseHandler = (response) => response;

export { errorResponseHandler, successResponseHandler };
